<template>
  <div>
    <b-modal
      footer="{null}"
      centered
      id="sim_card_gmcvs_unblock"
      title="Débloquer ma SIM"
      hide-footer
       no-close-on-esc
      no-close-on-backdrop
    >
      <div>
        <div v-if="!is_ok">
          <div class="modal-header-wrap text-center">
            <i class="kgk-mtn-app_blocking modal-header-icon yellow-muted"></i>
            <h3>Débloquer ma SIM</h3>
            <p class="text-muted">
              <span>Vous avez bloqué votre SIM par erreur ?</span><br />
              Cliquez sur le bouton ci dessous pour la débloquer.
            </p>
          </div>

          <div class="mt-3 mb-3 text-center">
            <button @click="go()" class="btn btn-primary">
              <b-spinner small v-if="is_loading" label="Loading..."></b-spinner>
              <span v-if="!is_loading">Débloquer ma SIM</span>
            </button>
          </div>
        </div>

        <div v-if="is_ok" class="text-center modal-success-error-message">
          <i
            class="mdi mdi-check"
          ></i>
          <p class="text-muted"><b>Votre carte SIM a été débloquée avec succès.</b> <br>Si vous n'arrivez pas à capter le réseau sur vote téléphone après le déblocage, veuillez redémarrer simplement votre téléphone.</p>
        </div>
      </div>
      <div></div>
    </b-modal>
  </div>
</template>

<script>
import { subscriber } from "@/services/";
export default {
  name: "SimCardUnBlock",
  mounted: async function () {},
  data: () => {
    return {
      is_ok: false,
      is_loading: false,
    };
  },
  methods: {
    go: async function () {
      if (!confirm(this.utils_get_config_message("unblock_sim_prevent"))) {
        return;
      }
      this.is_loading = true;
      var response = await subscriber.gmcvs("gmcvs_unblock");
      if (!_.isUndefined(response.unblocked)) {
        this.is_ok = true;
      }
      this.is_loading = false;
    },
  },
};
</script>
<style scoped lang="css">
#puk_details {
  font-weight: bold;
  font-size: 22px;
  letter-spacing: 2px;
}
</style>